import { MixedGroupedOddsOutrightsTabSelected } from '../components/tabs/mixed-grouped-odds-outrights-tabs.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export function useSelectedTab(
    oddsList: string[] | undefined,
    topicDetails: unknown,
): [MixedGroupedOddsOutrightsTabSelected, Dispatch<SetStateAction<MixedGroupedOddsOutrightsTabSelected | undefined>>] {
    const [selected, setSelected] = useState<MixedGroupedOddsOutrightsTabSelected | undefined>();

    useEffect(() => {
        setSelected(undefined);
    }, [topicDetails]);

    const selectedTab: MixedGroupedOddsOutrightsTabSelected = selected || (
        oddsList.length
            ? MixedGroupedOddsOutrightsTabSelected.Odds
            : MixedGroupedOddsOutrightsTabSelected.Outrights
    );

    return [selectedTab, setSelected];
}
